import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

declare global {
  interface Window {
    clarity?: (action: string, ...args: any[]) => void;
  }
}

const Analytics: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view with Microsoft Clarity
    if (window.clarity) {
      window.clarity('set', 'page', location.pathname);
    }
  }, [location]);

  return null;
};

export default Analytics;
